<template>
    <module-card :nextDisabled="nextDisabled" :nextFunction="next">
        <p>Take a moment to fill out your own Bulls-I.</p>

        <div v-for="prompt in myBullsI" :key="prompt.id" :id="'bulls_I_' + prompt.id">
            <div v-if="prompt.id <= maxVisited" @click="activate(prompt.id)" :class="{ 'fake-disabled': !active(prompt.id) }">
                <p v-html="prompt.prompt" class="prompt"></p>
                <v-avatar size="20" :style="{ backgroundColor: prompt.color }">
                    <span>{{ prompt.id }}</span>
                </v-avatar>
                <v-text-field outlined :clearable="active(prompt.id)" counter maxlength="30" label="Type your answer here" type="text" class="bulls-i-input" v-model="prompt.response"></v-text-field>
            </div>

            <!-- <v-row v-if="prompt.next && active(prompt.id)">
                <v-spacer></v-spacer>
                <v-col>
                    <v-btn large color="primary" @click="activate(prompt.next)" :disabled="!(prompt.response && prompt.response.trim().length > 0)">Next</v-btn>
                </v-col>
                <v-spacer></v-spacer>
            </v-row> -->
        </div>
    </module-card>
</template>

<script>
    import { sync } from 'vuex-pathify';
    import { every } from 'lodash';

    export default {
        data() {
            return {
                activePrompt: 1,
                maxVisited: 1
            };
        },
        computed: {
            myBullsI: sync('myBullsI')
        },
        mounted() {
            // determine max visited, but we'll activate an earlier one if it is unpopulated
            let firstUnpopulated = null;

            for (const o of this.myBullsI) {
                if (o.response && o.response.trim().length > 0) {
                    this.maxVisited = o.id + 1 > this.myBullsI.length ? this.myBullsI.length : o.id + 1;
                } else {
                    firstUnpopulated = firstUnpopulated === null ? o.id : firstUnpopulated;
                }
            }

            if (firstUnpopulated === null) {
                firstUnpopulated = this.maxVisited;
            }

            this.activate(firstUnpopulated);
        },
        methods: {
            active(prompt) {
                return parseInt(prompt) === parseInt(this.activePrompt);
            },
            activate(prompt) {
                this.activePrompt = prompt;
                this.$nextTick(() => this.showActive());
            },
            showActive() {
                let el = document.getElementById('bulls_I_' + this.activePrompt);
                el.scrollIntoView(false);
            },
            nextDisabled() {
                // all visible prompts need to be populated before proceeding.
                return !every(this.myBullsI, (o) => {
                    if (o.id > this.maxVisited) {
                        return true;
                    }

                    if (o.response && o.response.trim().length > 1) {
                        return true;
                    }

                    return false;
                });
            },
            next() {
                // next does two things:
                // 1. if all prompts have not been displayed, it will display an additional if all prior are populated and activate it.
                // 2. if all prompts have been displayed, and all are populated, it will advance to the next screen
                // note, we don't have to check if all displayed prompts have been populated; next will be disabled if not.

                if (this.maxVisited < this.myBullsI.length) {
                    this.maxVisited++;
                    this.activate(this.maxVisited);
                    return false;
                }

                return true;
            }
        }
    };
</script>

<style scoped>
    .v-avatar {
        margin-bottom: 5px;
    }

    .prompt {
        margin-bottom: 2px;
    }

    .fake-disabled {
        opacity: 50%;
    }
</style>
